module.exports = __webpack_public_path__ + "static/metroboomin-d945247d3a84b9842929c4d0a6e75554.jpg";